import { clearUserId } from 'utils/piwikUtils';
import { SettingsItems } from '../../constants';
import APIService from '../../services/APIService';

interface Props {
    hasGQPermissions: Boolean;
    username: string;
    onSettingClicked: (settingKey: string) => void;
}

export const GQSettingsMenu = ({
    hasGQPermissions,
    username,
    onSettingClicked,
}: Props) => {
    const onLogOutClick = event => {
        event.preventDefault();
        // APIService.logout clear user's app cookies, and returns a redirect URL 
        // to Auth0 logout page to clear the session cookies.
        APIService.logout().then(response => {
            clearUserId();
            window.location.href = response?.data?.redirectUrl;
        });
    };

    const onExternalTermsClick = () => {
        window.open('https://www.fitch.group/policies/', '_blank');
    };

    return (
        <div className="gq-navbar-settings-menu">
            {hasGQPermissions &&
                SettingsItems.map(item => {
                    return (
                        <div
                            key={item.id}
                            onClick={() => {
                                onSettingClicked(item.id);
                            }}
                            className="gq-navbar-settings-menu-item">
                            {item.label}
                        </div>
                    );
                })}
            <div className="gq-navbar-settings-menu-separator" />
            <div className="gq-navbar-settings-menu-text">{username}</div>
            <div
                onClick={onLogOutClick}
                className="gq-navbar-settings-menu-item">
                Logout
            </div>
            <div className="gq-navbar-settings-menu-separator" />
            <div
                onClick={onExternalTermsClick}
                className="gq-navbar-settings-menu-item"
                style={{
                    fontSize: 10,
                    fontFamily: 'geoquant',
                    height: 'auto',
                    alignItems: 'end',
                }}>
                Terms & Policies
            </div>
        </div>
    );
};
